<template>
    <div class="home">
     
      <CotizacionHomeComponent />
    </div>
  </template>
  
  <script>
  // @ is an alias to /src
  import CotizacionHomeComponent from '@/components/CotizacionHomeComponent.vue'
  
  export default {
    name: 'CotizacionView',
    components: {
        CotizacionHomeComponent
    }
  }
  </script>